import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no_pass",
  "use": "icon-no_pass-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-no_pass\">\r\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#FF5959\" />\r\n<path d=\"M5.94975 4.46447C5.55925 4.07397 4.92606 4.07394 4.53553 4.46447C4.14501 4.85499 4.14504 5.48818 4.53553 5.87868L6.65685 8L4.53553 10.1213C4.14501 10.5118 4.14504 11.145 4.53553 11.5355C4.92603 11.926 5.55922 11.9261 5.94975 11.5355L8.07107 9.41421L10.1924 11.5355C10.5829 11.926 11.2161 11.9261 11.6066 11.5355C11.9971 11.145 11.9971 10.5118 11.6066 10.1213L9.48528 8L11.6066 5.87868C11.9971 5.48816 11.9971 4.85496 11.6066 4.46447C11.2161 4.07397 10.5829 4.07394 10.1924 4.46447L8.07107 6.58579L5.94975 4.46447Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/no_pass.svg
// module id = 5YmT
// module chunks = 14